module.exports = __webpack_public_path__ + "images/Rohan_Mehta.jpg?v=454820938b888e844418222011ab8b6e";